import React, { forwardRef } from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// STYLES
import styles from './inputAppend.module.scss';

// MAIN COMPONENT
export const inputAppend = Component => forwardRef(({
  input: { append, ...input } = {},
  ...props
}, ref) => (
  <div className={clsx(
    append && styles.container,
    append && props.vertical && styles.vertical
  )}>
    <Component
      input={input}
      {...props}
      ref={ref}
    />
    {append}
  </div>
))
